var generateMenuFAQ = function generateMenuFAQ() {
  var CHAPTER_SELECTOR = '[data-chapter]';
  var MAIN_FAQ_SELECTOR = '.main-faq';
  var CONTAINER_MENU = '.main-faq__menu';
  var INPUT_TYPE = 'radio';
  var INPUT_CLASS_PREFIX = 'chapter-toggle';
  var LABEL_CLASS_PREFIX = 'chapter-label';
  var LABEL_NAME_PREFIX = 'menu-faq';
  function setupFAQVisibilityControls() {
    var chapters = document.querySelectorAll(CHAPTER_SELECTOR);
    var mainFaqContainer = document.querySelector(MAIN_FAQ_SELECTOR);
    var menuContainer = document.querySelector(CONTAINER_MENU);
    if (!chapters || !mainFaqContainer || !menuContainer) {
      return;
    }
    var styleElement = document.createElement('style');
    var dynamicCSS = '';
    chapters.forEach(function (chapterSection, index) {
      var chapterData = chapterSection.dataset.chapter;
      var chapterId = chapterSection.dataset.key;
      var inputId = "".concat(chapterId);
      var inputElement = document.createElement('input');
      inputElement.type = INPUT_TYPE;
      inputElement.id = inputId;
      inputElement.name = LABEL_NAME_PREFIX;
      inputElement.className = INPUT_CLASS_PREFIX;
      mainFaqContainer.prepend(inputElement);
      var labelElement = document.createElement('label');
      labelElement.textContent = chapterData;
      labelElement.setAttribute('for', inputId);
      labelElement.className = LABEL_CLASS_PREFIX;
      menuContainer.appendChild(labelElement);
      dynamicCSS += "\n      #".concat(inputId, ":checked ~ section .main-faq__menu .").concat(LABEL_CLASS_PREFIX, "[for='").concat(inputId, "'] {\n        color: #111111;\n        opacity: 1;\n      }\n      #").concat(inputId, ":checked ~ .main-faq__conteiner section[data-key='").concat(inputId, "'] {\n        display: block;\n        position: relative;\n        z-index: 3;\n      }\n    ");
      if (index === 0) {
        inputElement.checked = true;
      }
    });
    styleElement.textContent = dynamicCSS;
    mainFaqContainer.appendChild(styleElement);
  }
  setupFAQVisibilityControls();
};
var movimentCardFAQ = function movimentCardFAQ() {
  var MAIN_FAQ_SELECTOR = '.main-faq';
  var CARD_SELECTOR = '.main-faq__card';
  var cardCopied = false;
  var mainFaq = document.querySelector(MAIN_FAQ_SELECTOR);
  var originalCard = document.querySelector(CARD_SELECTOR);
  if (!mainFaq || !originalCard) {
    return;
  }
  if (!cardCopied) {
    var clonedCard = originalCard.cloneNode(true);
    mainFaq.appendChild(clonedCard);
    cardCopied = true;
  }
};
export { generateMenuFAQ, movimentCardFAQ };